import React from "react";
import { useSelector, useDispatch } from "react-redux";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/sagas/utilization";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";

export const FilterByBookingStatus = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.utilization.bookingStatusOptions);
  const selectedFilters = useSelector((state) => state.utilization.selectedBookingStatuses);
  const bookingStatusFilterLoading = useSelector(
    (state) => state.utilization.bookingStatusFilterLoading
  );

  return (
    <div className="select-box" style={{ width: "200px" }}>
      <p className="offers-title">Booking Status</p>
      {!bookingStatusFilterLoading ? (
        <MultiSelectDropdown
          options={options}
          selectedFilters={selectedFilters}
          placeholder="Select Type"
          numberDisplayed={1}
          multiple
          enableOnly
          onSelectChange={(data) => dispatch(actionCreators.updateBookingStatus(data))}
        />
      ) : (
        <button className="picky__input">
          <LoadingAnimation uiLoader />
        </button>
      )}
    </div>
  );
};
